<template>
  <el-dialog title="拒绝售后" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
      <el-form-item label="认领人员：" prop="customerId">
        <el-select v-model="form.customerId" value-key="value" placeholder="根据姓名/手机号搜索" filterable clearable remote :remote-method="searchUsers" :loading="isLoading">
          <el-option v-for="(it,idx) in userList" :label="it.name + (it.pho? '('+it.pho + ')':'')" :key="idx" :value="it.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递单号：" prop="logisticsNumber">
        <el-input v-model="form.logisticsNumber" placeholder="请输入快递单号" />
      </el-form-item>
      <el-form-item label="驳回原因：" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入驳回原因" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>

import goodsOrderApi from '@/api/order/goodsOrder'
function initFormBean() {
  const formBean = {
    afterId: null,
    customerId: '',
    logisticsNumber: null,
    remark: null,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        customerId: [{ required: true, message: '请选择认领人员', trigger: 'change' }],
        logisticsNumber: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
      },
      isRepSub: false,
      userList: [],
      isLoading: false // 添加 loading 状态
    }
  },
  created() {
  },
  methods: {
    handleRefuse(row) {
      if (row.customerId) {
        this.userList = [{ id: row.customerId, name: row.customerInfo && row.customerInfo.name, pho: row.customerInfo && row.customerInfo.pho }]
        this.form.customerId = row.customerId
      }
      this.form.logisticsNumber = row.deliverInfo || ''
      this.form.afterId = row.id
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.isLoading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.isLoading = false;
          this.getUserList(query)
        }, 500);
      } else {
        this.userList = [];
      }
    },
    getUserList(query) {
      goodsOrderApi.getUserList({ state: 1, isDeparted: 0, nameOrPho: query, pageNo: 1, pageSize: 100 }).then((res) => {
        let { list } = res.data;
        let arr = []
        list && list.forEach(item => {
          let { id, name, pho } = item.customer
          arr.push({ id, name, pho })
        })
        this.userList = arr;
      });
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      console.log(row)
      this.resetForm()
      this.form = { ...row };
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcEditData() {


    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      return params
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          if (this.isRepSub) return
          this.isRepSub = true
          goodsOrderApi.UpdateConfirmOrderAfterState(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.goodsList.splice(index, 1)

    },
    handleAddItem() {
      this.form.goodsList.push({ goodsId: '', goodsCount: '' })
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  // padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

// .el-form-item--small.el-form-item {
//   width: 48%;
//   display: inline-block;
//   vertical-align: top;
// }
// .el-form-item--small.el-form-item.width100 {
//   width: 97%;
// }
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}

.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
